import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../components/atoms/Button";
import { Link } from "react-router-dom";
import MainLayoutDetail from "../../components/layout/MainLayoutDetail";
import SectionBox from "../../components/layout/SectionBox";
import { loginApi } from "../../api/authApi";
import { useAuthStore } from "../../store/useAuthStore";
import { Eye, EyeOff } from "lucide-react";
// @ts-ignore
import ReCAPTCHA from "react-google-recaptcha";

export default function Login() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState(false);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);


  const handleCaptchaChange = (token: string | null) => {
    setCaptchaToken(token);
  };

  const location = useLocation();
  const navigate = useNavigate();
  const currentLang = location.pathname.startsWith("/id") ? "id" : "en";

  // const login = useAuthStore((state) => state.login);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!captchaToken) {
      setError("Please verify that you are not a robot");
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const res = await loginApi(formData.email, formData.password);

      // 🔐 SIMPAN SEMUA RESPONSE
      useAuthStore.getState().setAuth({
        accessToken: res.token,
        type: res.type,
        status: res.is_active,
        isVerified: res.is_verified,
        dataProfile: res.data_profile,
        email: formData.email,
      });

      // 🔴 BELUM AKTIF → OTP
      // 🔴 BELUM AKTIF → OTP
      if (res.is_active === false) {
        if (res.type === "company") {
          navigate(`/${currentLang}/login/admin/otp-verification`);
          return;
        }

        if (res.type === "candidate") {
          navigate(`/${currentLang}/login/user/otp-verification`);
          return;
        }
      }

      // 🟢 SUDAH AKTIF
      if (res.type === "candidate") {
        navigate(`/${currentLang}/jobs`);
        return;
      }

      if (res.type === "company") {
        navigate(`/${currentLang}/admin/user-profile`);
        return;
      }


      // 🟢 SUDAH AKTIF → HOME
    } catch (err) {
      setError("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };




  return (
    <MainLayoutDetail>
      <div className="container-section mx-auto mt-32 px-6">
        <SectionBox
          className="md:flex md:flex-col md:justify-center md:min-h-[70vh]"
          titleClassName="text-2xl md:text-3xl text-white"
          background="radial-gradient(circle at 50% -100%, rgba(255,255,255,0) 0%, #123b7c 70%)"
        >
          <div className="flex items-center justify-center">
            <form
              onSubmit={handleSubmit}
              className="bg-white p-4 md:p-8 rounded-2xl shadow-md w-96"
            >
              <h2 className="text-2xl font-semibold mb-6 text-gray-800 text-center">
                Login
              </h2>

              <div className="flex flex-col gap-4">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="border border-gray-300 rounded-lg p-3 text-sm"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />

                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    className="border border-gray-300 rounded-lg p-3 text-sm w-full pr-10"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />

                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>

                <ReCAPTCHA
                  sitekey="6LfPuzcsAAAAAItzND8FHtg9SJvsFhRNDZJmiMnH"
                  onChange={handleCaptchaChange}
                />

                {error && (
                  <p className="text-sm text-red-500 text-center">{error}</p>
                )}

                <Button
                  type="submit"
                  className="w-full bg-primary hover:bg-secondary"
                >
                  {loading ? "Logging in..." : "Login"}
                </Button>
              </div>

              <p className="text-sm text-gray-500 mt-2 text-end">
                <Link
                  to={`/${currentLang}/forgot-password`}
                  className="text-primary  hover:underline"
                >Forgot Password
                </Link>
              </p>

              <p className="mt-6 text-sm text-gray-500 text-center">
                Don’t have an account?{" "}
                <Link
                  to={`/${currentLang}/register`}
                  className="text-primary hover:underline"
                >
                  Sign up
                </Link>
              </p>
            </form>
          </div>
        </SectionBox>
      </div>
    </MainLayoutDetail>
  );
}
